import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import useOnclickOutside from 'react-cool-onclickoutside';
import {
  DropdownContainer,
  FilterContainer,
  FilterLabel,
  OptionsContainer,
  Option,
} from './common/styles';
import { DATE_RANGES } from '../constants';
import DropdownArrow from './common/dropdown-arrow';

const SDropdownContainer = styled(DropdownContainer)`
  width: 155px;
`;

const SOptionsContainer = styled(OptionsContainer)`
  width: 200px;
`;

const Opt = styled(Option)`
  padding: 5px 8px 0 8px;
  height: 40px;

  &:hover {
    border-radius: 4px;
  }
`;

const CalendarIcon = styled.span`
  color: ${props => props.theme.secondaryColor};
  font-size: 18px !important;
`;

const DropdownText = styled.span`
  color: ${props => props.theme.bodyColor};
  font: 700 14px/120% ${props => props.theme.fontFamilyBody};
`;

export default function DateRanges({ daysAgo, onChange }) {
  const [expanded, setExpanded] = React.useState(false);
  const ref = useOnclickOutside(() => {
    setExpanded(false);
  });

  const toggleShowOptions = e => {
    e && e.preventDefault();
    setExpanded(!expanded);
  };

  const setDays = v => e => {
    e && e.preventDefault();
    setExpanded(false);
    onChange(v);
  };

  return (
    <FilterContainer ref={ref}>
      <FilterLabel>Date Ranges</FilterLabel>
      <SDropdownContainer onClick={toggleShowOptions}>
        <CalendarIcon className="fa fa-calendar-o" />
        <DropdownText>{_.find(DATE_RANGES, { value: daysAgo }).label}</DropdownText>
        <DropdownArrow expanded={expanded} />
      </SDropdownContainer>
      {expanded && (
        <SOptionsContainer>
          {DATE_RANGES.map(({ value, label }) => (
            <Opt
              key={value}
              className={classNames({ selected: value === daysAgo })}
              onClick={setDays(value)}
            >
              {label}
            </Opt>
          ))}
        </SOptionsContainer>
      )}
    </FilterContainer>
  );
}

DateRanges.propTypes = {
  daysAgo: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};
